export {
  mapDtoToAccommodationsBadgeTypes,
  mapDtoToAccommodationsPage,
  mapDtoToAccommodationsPoints,
  mapDtoToAccommodationsTypes,
} from "./mappers";
export type { AccommodationsPageType } from "./types";
